import { dialOf } from "../../lib/countries";

export const dialFor = (cc) => dialOf(cc || "MA") || "+212";
